import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Table, message, Spin, Button, Modal } from "antd";
import { AuthContext } from "../context/AuthContext";
import SendMail from "../components/SendMail";

export default function NewEmployees() {
    const [employees, setEmployees] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentDate, setCurrentDate] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [data, setData] = useState(null);

    const { authData, backUrl } = useContext(AuthContext);

    useEffect(() => {
        const today = new Date();
        const formattedDate = today.toISOString().split("T")[0];
        setCurrentDate(formattedDate);
    }, []);

    useEffect(() => {
        if (currentDate) fetchEmployees();
    }, [currentDate]);

    const fetchEmployees = async () => {
        try {
            setLoading(true);
            const res = await axios.get(
                `${backUrl}/api/emp/employees/?date_of_joining=${currentDate}`,
                {
                    headers: {
                        Authorization: `Bearer ${authData?.access}`,
                    },
                }
            );
            setEmployees(res.data.results || []);
        } catch {
            message.error("Failed to fetch employees");
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        {
            title: "Employee ID",
            dataIndex: "emp_code",
        },
        {
            title: "Name",
            render: (_, record) =>
                `${record.first_name || ""} ${record.last_name || ""}`,
        },
        {
            title: "Organisation",
            dataIndex: "organisation_name",
        },
        {
            title: "Department",
            dataIndex: "department_name",
        },
        {
            title: "Designation",
            dataIndex: "designation_name",
        },
        {
            title: "Date of Joining",
            dataIndex: "date_of_joining",
        },
        {
            title: "Action",
            render: (_, record) => (
                <Button
                    type="primary"
                    onClick={() => {
                        setData(record);
                        setShowModal(true);
                    }}
                    style={{background:'#0e497b', color:'white'}}
                >
                    Send Welcome Note
                </Button>
            ),
        },
    ];

    return (
        <>
            <Spin spinning={loading}>
                <Table
                    columns={columns}
                    dataSource={employees}
                    rowKey={(record) => record.id}
                    pagination={{ pageSize: 10 }}
                    components={{
                        header: {
                            cell: (props) => (
                                <th
                                    {...props}
                                    style={{
                                        backgroundColor: "#0e497b",
                                        color: "white",
                                    }}
                                >
                                    {props.children}
                                </th>
                            ),
                        },
                    }}
                />
            </Spin>

            {/* ✅ MODAL */}
            <Modal
                open={showModal}
                title="Send Welcome Note"
                onCancel={() => {
                    setShowModal(false);
                    setData(null);
                }}
                footer={null}
                width={900}
                destroyOnClose
            >
                {data && (
                    <SendMail
                        employee={data}
                        onClose={() => {
                            setShowModal(false);
                            setData(null);
                        }}
                    />
                )}
            </Modal>
        </>
    );
}
